//combine reducer
import { combineReducers } from "redux";

//reducers
import LoginReducer from "../Components/Login/LoginReducer";
import OtpVerificationReducer from "../Components/OtpVerification/OtpVerificationReducer";
import DashboardReducer from "../Components/Dashboard/DashboardReducer";
import InvitationHandlerReducer from "../Components/InvitationHandler/InvitationHandlerReducer";
import CareCircleReducer from "../Components/CareCircle/CareCircleReducer"
import AlertReducer from "../Components/Alert/AlertReducer"
import SettingsReducer from "../Components/Settings/SettingsReducer"
import UpgradeHandlerReducer from "../Components/UpgradeHandler/UpgradeHandlerReducer";
import PlansReducer from "../Components/Plans/PlansReducer";

export default combineReducers({
  Login: LoginReducer,
  OtpVerification: OtpVerificationReducer,
  Dashboard: DashboardReducer,
  InvitationHandler: InvitationHandlerReducer,
  CareCircle: CareCircleReducer,
  Alert: AlertReducer,
  Settings:SettingsReducer,
  UpgradeHandler: UpgradeHandlerReducer,
  Plans: PlansReducer,
});
